import { useIntl } from 'react-intl';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import Input from 'src/componentes/input';
import Panel from 'src/componentes/panel';
import StatusBadge from 'src/componentes/StatusBadge';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import AreaLookup from 'src/lookups/item-organizacao';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';

function DadosPesquisaClimaTabContent({ disabled, model }) {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const status = model.getModel('status').value;

  return (
    <Panel
      header={capitalizeFirstLetter(
        intl.formatMessage({ id: 'label.informacoes' })
      )}
    >
      <Row>
        <Col md={3}>
          <Input model={model.getModel('idIntegracao')} disabled />
        </Col>
        <Col>
          <Input model={model.getModel('nome')} disabled={disabled} required />
        </Col>
        {status?.descricao && (
          <Col xs="auto">
            <FormGroup>
              <Label>
                {capitalizeFirstLetter(intl.formatMessage({ id: 'status' }))}
              </Label>
              <div>
                <StatusBadge
                  text={capitalizeFirstLetter(
                    intl.formatMessage({ id: status.descricao })
                  )}
                  textColor={status.corFundo ? status.cor : undefined}
                  backgroundColor={status.corFundo || status.cor}
                />
              </div>
            </FormGroup>
          </Col>
        )}
      </Row>
      <Row>
        <Col md={3}>
          <AreaLookup
            disabled={disabled}
            controlStyle={{ minHeight: 48 }}
            model={{
              label: capitalizeFirstLetter(resources.area),
              value: model.getModel('area').value,
              requestChange: model.getModel('area').requestChange,
            }}
            clearable
          />
        </Col>
        <Col md={9}>
          <ColaboradorEGrupoSimplificadoLookup
            abrirEmDrawer
            controlStyle={{ minHeight: 48 }}
            disabled={disabled}
            exibirGrupos={false}
            labelComoTitulo
            compactMulti
            multi
            model={{
              label: capitalizeFirstLetter(resources.responsaveis),
              value: model.getModel('responsaveis').value,
              requestChange: model.getModel('responsaveis').requestChange,
              errors: model.getModel('responsaveis').errors,
            }}
            required
          />
        </Col>
        <Col md={12}>
          <Input
            type="textarea"
            rows={4}
            model={model.getModel('descricao')}
            disabled={disabled}
          />
        </Col>
      </Row>
    </Panel>
  );
}

export default DadosPesquisaClimaTabContent;
